import React from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { compose, withHandlers, withProps } from "recompose";

export const EditDeleteButtonsModal = ({
  editProps,
  deleteProps,
  url,
  id,
  wrapOnDelete,
  wrapOnEdit,
  hideEdit,
  allowDelete,
}) =>
  
  (
    <span>
      {!hideEdit &&
        <Button className="btn btn-primary btn-sm mr-1 fix-bg-edit-btn"
          style={{borderRadius:"6px",backgroundColor: "rgb(114, 181, 102)", borderColor:"rgb(114, 181, 102)"}}
              {...editProps}
          onClick={wrapOnEdit}
        >
          <span className="fa fa-edit" style={{fontSize:"15px"}}/>
        </Button>
      }
      {allowDelete && (
        <Button style={{borderRadius:"6px",backgroundColor: "rgb(252, 102, 102)", borderColor:"rgb(252, 102, 102)"}}
          color="danger"
          size="sm"
          {...deleteProps}
          onClick={wrapOnDelete}
        >
          <span className="fa fa-trash" style={{fontSize:"15px"}}/>
        </Button>
      )}
    </span>
  );

const enhance = compose(
  withProps(({ onDelete }) => ({
    allowDelete: !!onDelete,
  })),
  withHandlers({
    wrapOnDelete:
      ({ id, onDelete }) =>
      () =>
      onDelete(id),

      wrapOnEdit:
      ({ id, onEdit }) =>
      () =>
        onEdit(id),
      }),
  
);

export default enhance(EditDeleteButtonsModal);
